import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAddressByIdMutationVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  set: Types.Addresses_Set_Input;
}>;


export type UpdateAddressByIdMutation = { __typename?: 'mutation_root', update_addresses_by_pk?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string, updated_at: any } | null };


export const UpdateAddressByIdDocument = gql`
    mutation updateAddressById($id: uuid!, $set: addresses_set_input!) {
  update_addresses_by_pk(_set: $set, pk_columns: {id: $id}) {
    id
    street_1
    street_2
    city
    state
    postal_code
    country
    updated_at
  }
}
    `;
export type UpdateAddressByIdMutationFn = Apollo.MutationFunction<UpdateAddressByIdMutation, UpdateAddressByIdMutationVariables>;

/**
 * __useUpdateAddressByIdMutation__
 *
 * To run a mutation, you first call `useUpdateAddressByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressByIdMutation, { data, loading, error }] = useUpdateAddressByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateAddressByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddressByIdMutation, UpdateAddressByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddressByIdMutation, UpdateAddressByIdMutationVariables>(UpdateAddressByIdDocument, options);
      }
export type UpdateAddressByIdMutationHookResult = ReturnType<typeof useUpdateAddressByIdMutation>;
export type UpdateAddressByIdMutationResult = Apollo.MutationResult<UpdateAddressByIdMutation>;
export type UpdateAddressByIdMutationOptions = Apollo.BaseMutationOptions<UpdateAddressByIdMutation, UpdateAddressByIdMutationVariables>;